module.exports = __webpack_public_path__ + "media/bootstrap-icons/hourglass-split-91f0a33b.svg";